import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex justify-between gap-0 w-full !bg-surface-0 py-1.5 pr-0 mx-3.5" };
const _hoisted_2 = { class: "flex flex-col justify-center gap-0 w-full min-w-[15.625rem]" };
const _hoisted_3 = { class: "flex items-center text-surface-700 text-sm font-semibold ellipsis truncate max-w-[250px] gap-2" };
const _hoisted_4 = {
    key: 0,
    class: "fa-regular fa-triangle-exclamation text-orange-500 dark:text-orange-500"
};
const _hoisted_5 = { class: "text-surface-500 text-xs font-normal" };
const _hoisted_6 = { class: "flex flex-col items-end w-full min-w-[5.313rem] font-semibold text-surface-900 text-xs gap-3" };
const _hoisted_7 = { class: "" };
const _hoisted_8 = { class: "" };
const _hoisted_9 = { class: "text-orange-500 dark:text-orange-500" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'MainParentCell',
    props: {
        node: {},
        hasProblem: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_RouterLink, {
                            to: `/user/${__props.node.userData.id}#general`
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.node.userData.name), 1)
                            ]),
                            _: 1
                        }, 8, ["to"]),
                        (__props.hasProblem)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, null, 512)), [
                                [
                                    _directive_tooltip,
                                    _ctx.$tf('timeManagement.loggingDay.logsForDay.unknownProjectLog|Beazonosítatlan projektre loggolt idő'),
                                    void 0,
                                    { top: true }
                                ]
                            ])
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(__props.node.userData.title), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$tf("timeManagementOverview.workTime|Munkaidő")), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$tf("timeManagementOverview.loggedTime|Rögzített idő")), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$tf("timeManagementOverview.timeOff|Szabadság")), 1)
                ])
            ]));
        };
    }
});
